import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';

const style = {
  width: '100%',
};

const BackButton = ({ backLabel, backLink }) => {
  const navigate = useNavigate();
  return (
    <Button
      style={style}
      color="secondary"
      onClick={() => {
        navigate(backLink);
      }}
    >
      {backLabel}
    </Button>
  );
};

export default BackButton;

BackButton.propTypes = {
  backLabel: PropTypes.string.isRequired,
};
